export default __webpack_public_path__ + "static/media/grey-square-tick.d3efd840.svg";